<template>
  <NodeArticle v-if="node" v-bind="node" />
</template>

<script lang="ts" setup>
definePageMeta({
  path: '/artikel/:slug(.*)*',
  languageMapping: {
    fr: '/articles/:slug(.*)*',
    it: '/articoli/:slug(.*)*',
  },
  drupalRoute: true,
})

const { entity: node } = await useDrupalRouteQuery('nodeArticle')

useRouteCache((c) => c.setCacheable().setMaxAge(600))
await renderPageDependencies()
</script>

<script lang="ts">
export default {
  name: 'PageArticleSlug',
}
</script>
